import script from "./ModelCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelCard.vue?vue&type=script&setup=true&lang=js"

import "./ModelCard.vue?vue&type=style&index=0&id=63ebbd74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ebbd74"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QSpace,QImg,QRadio});
